import HourglassSvg from '@assets/images/svg/hourglass.svg';
import React from 'react';
import { View } from 'react-native';

export interface HourglassIconProps {
  size?: number;
  color?: string;
}

const VIEWBOX_WIDTH = 14;
const VIEWBOX_HEIGHT = 19;

/** Figma reservation pending — hourglass (14×19) */
export function HourglassIcon({
  size = VIEWBOX_HEIGHT,
  color = '#E64A19',
}: Readonly<HourglassIconProps>) {
  const width = (size * VIEWBOX_WIDTH) / VIEWBOX_HEIGHT;
  return (
    <View
      style={{
        width,
        height: size,
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <HourglassSvg width={width} height={size} color={color} />
    </View>
  );
}

export default HourglassIcon;
